export default function() {
  const widgetName = 'videoWidget';
  const widgetOpts = fairVideoOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
      , detectIpad: IPADDETECTED
      // options
      , multiVideo: false
      , showOnMobile: true
      , maxVideos: 1
      , trackingGA: {
        present: false,
        event: 'event',
        gaObj: {
          eventCategory: 'Videos',
          eventAction: '',
          eventLabel: '',
        }
      }
      , videoWidgetLoaded: function(){
        const iframe = $(`#${widgetName}`).find('iframe');
        const iframeId = iframe.attr('id');
        const videoWrapper = $('.video-wrapper');
        
        if (iframeId === undefined) {
          videoWrapper.hide();
          $('.tier-three .widget-wrapper').css('padding', '0');
        }
      }
  });

};
